import { apiClient } from '../apiClient';
import type { ILead } from '../types/lead';

interface ILeadProps {
    id: number;
    data: Partial<ILead>;
}

export const updateLead = async ({ id, data }: ILeadProps) => {
    const response = await apiClient.patch(`property-leads/${id}`, {
        json: {
            ...data,
        },
    });
    return (await response.json()) as ILead;
};
